import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['file', 'alert', 'submit', 'progress']
  static classes = ['hide', 'disabled']
  static values = {
    maxMbyte: { type: Number, default: 10 }
  }

  connect () {
    super.connect()
  }

  validate () {
    const selectedFile = this.fileTarget.files[0]
    if (this.canUpload(selectedFile)) {
      this.alertTarget.classList.remove(this.hideClass)
      this.submitTarget.classList.add(this.disabledClass)
    } else {
      this.alertTarget.classList.add(this.hideClass)
      this.submitTarget.classList.remove(this.disabledClass)
    }
  }

  canUpload (file) {
    return file && (file.size > this.maxMbyteValue * 1024 * 1024)
  }

  showProgress () {
    this.progressTarget.classList.remove(this.hideClass)
  }
}
